export class AccountDetails {
    id: string;
    abcClassification: string;
    name: string;
    additionalName: string;
    registrationNumber: string;
    website: string;
    organizationType: string;
    language: string;
    duns: string;
    chamberOfCommerceId: string;
    vatNumber: string;
    companyHolding: string;
    printLogo: string;
    brandedPortalLogo: string;
    watermark: string;
    domains: any[];
    smtpDetails: any[];
    accountId: string;
    sellerAccount: any;
    country: string;
    // allowPayTM: boolean;
}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/accounts/details/account-details.model.ts